// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__pB4E1","textCenter":"styles_textCenter__2iw2I","toArchives":"styles_toArchives__3n5B3"};